import DialogModal from "../DialogModal";
import useLocalStorage from "../../hooks/useLocalStorage";

function WelcomePopup() {
  const [showWelcomePopup, setShowWelcomePopup] = useLocalStorage({
    key: "showWelcomePopup",
    initialValue: true,
  });

  return (
    <DialogModal
      show={showWelcomePopup}
      onHide={() => {
        setShowWelcomePopup(false);
      }}
      title="Welcome to the new portal Dashboard!"
      saveButtonProps={{
        saveText: "Got it!",
        onClick: () => {
          setShowWelcomePopup(false);
        },
      }}
      cancelButtonProps={{
        className: "tw-hidden",
        onClick: undefined,
      }}
    >
      <p className="tw-text-base">
        Here, you will find Diligent's latest news, at-glance delivery metrics,
        and much more!
      </p>
      <p className="tw-text-base">
        <b>Note:</b> If you prefer to keep the Order History as your Landing
        Page, scroll down to the bottom of this Dashboard and move the Landing
        Page switch to Off.
      </p>
    </DialogModal>
  );
}

export default WelcomePopup;
